import React, { useEffect, useState } from "react";
import { Modal, Stack } from "react-bootstrap";
import PackageSelectorPopOutStyles from "./PackageSelectorPopOut.styles";
import BUTTON from "../../../button/Button.component";
import { IModalProps, DefaultModalProps } from "./PackageSelectorPopOut.types";
import { ClickEvent } from "../../../../shared/types/event.types";
import PACKAGE_LIST from "../list-component/PackageList.component";
import { ProjectPackageSummaryVM } from "../../../../api/generated/models";

// istanbul ignore next
const getModalClassname = (packages: Array<ProjectPackageSummaryVM>) => {
  if (packages && packages.length) {
    return packages.length >= 8 ? "lg" : "";
  }
  return "";
};

const PACKAGE_SELECTOR_MODAL: React.FC<IModalProps> = (props: IModalProps) => {
  const { handleClose, centered, subscription } = props;
  const { data } = subscription;

  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(props.show);
  }, [props.show]);

  return (
    <PackageSelectorPopOutStyles.PackageSelectorModal
      data-testid="package-selector-modal"
      dialogClassName={`package-selector-modal ${getModalClassname(
        data?.packages
      )}`}
      show={show}
      centered={centered}
      onHide={handleClose}
    >
      <PackageSelectorPopOutStyles.PackageSelectorModalHeader
        className="package-selector-modal-header"
        closeButton
      >
        <div>
          <Modal.Title>
            {
              /* istanbul ignore next */ data &&
              data.packages &&
              data.packages.length
                ? data.packages.length
                : ""
            }{" "}
            Packages
          </Modal.Title>
        </div>
      </PackageSelectorPopOutStyles.PackageSelectorModalHeader>
      <Modal.Body>
        <Stack>
          {data && data.packages && data.packages.length && (
            <PACKAGE_LIST packageList={data.packages} />
          )}
        </Stack>
      </Modal.Body>
      <Modal.Footer>
        <BUTTON
          variant="secondary"
          className="back-button blue-theme no-scale"
          onClick={
            /* istanbul ignore next */ (event: ClickEvent) => {
              event.preventDefault();
              handleClose();
            }
          }
        >
          Cancel
        </BUTTON>
      </Modal.Footer>
    </PackageSelectorPopOutStyles.PackageSelectorModal>
  );
};

PACKAGE_SELECTOR_MODAL.defaultProps = DefaultModalProps;
export default PACKAGE_SELECTOR_MODAL;
